function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import xhr from './xhr';
import { getNetwork } from './utils';

var Cat = function () {
    function Cat(config) {
        _classCallCheck(this, Cat);

        this.project = 'mars-webloc-new';
        this.env = config.env;
        this.pageUrl = config.project;
        this.uuid = config.uuid;
        this.errorLogList = [];
        this.requestLogList = [];
        this.process = []; // 记录定位程序过程，用于查询日志走的哪发生错误。
        this.host = {
            prod: 'catfront.dianping.com',
            test: 'catfront.51ping.com'
        };
    }

    Cat.prototype.encodeDataBeforeSend = function encodeDataBeforeSend(array) {
        return 'c=' + encodeURIComponent(JSON.stringify(array));
    };

    Cat.prototype.pushErrorLog = function pushErrorLog(errorLog) {
        // 例如
        // errorLog = {
        //     sec_category: '错误类型,html-error',
        //     level: '错误等级，info'
        //     content: '错误内容'
        // }
        this.errorLogList.push(errorLog);
    };

    Cat.prototype.pushRequestLog = function pushRequestLog(requestLog) {
        // 例如
        // requestLog ={
        //     name: "app2",
        //     statusCode: 200, // 500或200
        //     responsetime: 320,
        //     content: "error"
        // }
        requestLog.timestamp = Date.now();
        this.requestLogList.push(requestLog);
    };

    Cat.prototype.sendErrorLog = function sendErrorLog() {
        var _this = this;

        if (this.errorLogList.length === 0) {
            return;
        }
        var data = this.errorLogList.map(function (item) {
            return {
                project: _this.project,
                pageUrl: _this.pageUrl,
                category: "jsError",
                sec_category: item.sec_category,
                level: item.level || "error",
                network: getNetwork(),
                unionId: _this.uuid,
                content: item.content
            };
        });
        var options = {
            data: this.encodeDataBeforeSend(data),
            method: 'POST',
            headers: {
                "Content-type": "application/x-www-form-urlencoded"
            }
        };
        var url = location.protocol + '//' + (this.env === 'prod' ? this.host.prod : this.host.test) + '/api/log?v=1';
        xhr(url, options, function (error, result) {
            if (!error) {
                // 如果error为null
                _this.errorLogList = [];
            }
        });
    };

    Cat.prototype.sendRequestLog = function sendRequestLog() {
        var _this2 = this;

        if (this.requestLogList.length === 0) {
            return;
        }
        var data = this.requestLogList.map(function (item) {
            var _ref;

            return _ref = {
                connectType: "",
                firstCategory: "ajaxError",
                logContent: item.content,
                pageUrl: _this2.pageUrl,
                project: _this2.project,
                realUrl: _this2.pageUrl,
                requestbyte: "0",
                resourceUrl: item.name,
                responsebyte: "0",
                responsetime: item.responsetime + '',
                secondCategory: item.name,
                statusCode: "|" + item.statusCode
            }, _ref['statusCode'] = "|" + item.statusCode, _ref.timestamp = item.timestamp, _ref.type = "JavaScript", _ref;
        });
        var info = {
            container: "",
            infos: data,
            network: "",
            operator: "",
            os: "",
            region: "",
            unionId: this.uuid
        };
        var options = {
            data: JSON.stringify(info),
            // data: encodeDataBeforeSend(info),
            method: 'POST'
        };
        var url = location.protocol + '//' + (this.env === 'prod' ? this.host.prod : this.host.test) + '/batch?v=1';
        xhr(url, options, function (error, result) {
            if (!error) {
                // 如果error为null
                _this2.requestLogList = [];
            }
        });
    };

    return Cat;
}();

export default Cat;